import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params } from '@angular/router';
import { LocaleService } from '@shared/services/locale.service';

@Component({
	selector: 'app-payment-fail',
	templateUrl: './payment-fail.component.html',
	styleUrls: ['./payment-fail.component.scss'],
})
export class PaymentFailComponent implements OnInit {
	constructor(private route: ActivatedRoute, private title: Title, public locale: LocaleService) {}

	embedded: boolean = false;
	adID: string;

	ngOnInit(): void {
		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['adID']) this.adID = queries['adID'];
			if (queries['embedded']) this.embedded = queries['embedded'];
		});

		this.title.setTitle(this.locale.translations['payment']['n343'] + ' | ' + this.locale.translations['header']['n0']);
	}
}
